<template>
  <div v-if="show" class="bg-primary text-white w-100 h4 pt-3 pb-2 text-center" style="margin-top: -20px">
    Ambiente de testes/desenvolvimento
  </div>
</template>

<script setup>

const show = ref(false)

onMounted(() => {
  show.value = window.location.href.includes("dev.seurole.com.br") || window.location.href.includes("localhost")
})

</script>
